import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AdaCustomization, PopUpService } from 'core/index';

@Component({
  selector: 'lms-customization-detail',
  templateUrl: './customization-detail.component.html',
  styleUrls: ['./customization-detail.component.scss']
})
export class CustomizationDetailComponent implements OnInit {
  public customization: AdaCustomization;
  public filters: Map<string, string>;

  constructor(
    public route: ActivatedRoute,
    public location: Location,
    public router: Router,
    public popupService: PopUpService
  ) {}

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.customization = data['customization'];
      this.filters = new Map<string, string>().set('customizationId', this.customization.id);
    });
  }

  goBack(): void {
    this.router.navigate(['/customizations']);
  }

  onUpdateCustomization(customization: AdaCustomization): void {
    this.customization = customization;
  }
}
